import { i18n } from '@flowwai-frontend/shared/common-components'
import { validateEmailField } from '@flowwai-frontend/shared/sales-crm/sales-crm-core'

export interface ValidationReturnType {
   isValid: boolean
   errorMessage?: string
}

export const validateEmail = (
   email: string | null | undefined
): ValidationReturnType => {
   const response = validateEmailField(email)
   if (response.errorMessage === 'Invalid') {
      return {
         isValid: false,
         errorMessage: i18n.t('auth:errorMessages.invalidEmail')
      }
   } else if (response.errorMessage === 'Required') {
      return {
         isValid: false,
         errorMessage: i18n.t('auth:errorMessages.requiredEmail')
      }
   }
   return response
}
